// Name an iframe this, and it will load its pages without the main nav.
// Usage: <iframe name={HIDE_NAV_IFRAME_NAME} ... />
export const HIDE_NAV_IFRAME_NAME = "hide-nav"
